import React from "react"
import { useState, useEffect } from 'react';
import { useMsal, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import {  checkGroupsInStorage, getGroupsFromStorage } from './StorageUtils';
import { loginRequest } from './authConfig';
import LoadingSection from "../components/atoms/loadingsection/LoadingSection";

interface IdTokenClaims {
    groups?: string[];
}

export const RouteGuard = ({ Component, ...props }: { Component?: React.FC, requiredGroups: string[], children?: any  }) => {
    const { instance } = useMsal();
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
    const [message, setMessage] = useState<boolean | string | null>(null);

    const onLoad = async () => {
        const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];

        // check either the ID token or a non-expired storage entry for the groups membership claim
        if (!activeAccount?.idTokenClaims?.groups && !checkGroupsInStorage(activeAccount)) {
            setMessage('Användaren är inte medlem i någon säkerhetsgrupp för applikationen.');
            return;
        }
        const idTokenClaims = activeAccount.idTokenClaims as IdTokenClaims;

        const hasRequiredGroup = props.requiredGroups?.some((group) =>
            idTokenClaims.groups?.includes(group) || getGroupsFromStorage(activeAccount)?.includes(group)
        );

        if (!hasRequiredGroup) setMessage(`Användaren saknar nödvändiga rättigheter för att visa sidan. Kontrollera att användaren är medlem i rätt säkerhetsgrupp för applikationen.`)
        setIsAuthorized(hasRequiredGroup);
    };

    useEffect(() => {
        onLoad();
        // eslint-disable-next-line
    }, [instance]);

    const authRequest = {
        ...loginRequest,
    };

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            {isAuthorized === null ? (
                <LoadingSection text="Laddar.." />
            ) : isAuthorized ? (
                <div>{props.children}</div>
            ) : (
                <div style={{
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '4px',
                    padding: '20px',
                    color: '#721c24',
                    marginBottom: '20px'
                  }}>
                    <h2 style={{
                      fontSize: '24px',
                      fontWeight: 'bold',
                      marginTop: '0'
                    }}>{ message }</h2>
                    <h4 style={{
                      fontSize: '16px',
                      marginBottom: '0'
                    }}>Kontakta systemadministratörern.</h4>
                </div>
            )}
        </MsalAuthenticationTemplate>
    );
};
